
import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { BadgeColor, GalaxyBadgeModule } from '@vendasta/galaxy/badge';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { ConversationPipesModule } from '../../../../../../../pipes';
import { TicketInfo } from '../inbox-ticket/inbox-ticket.component';

@Component({
  selector: 'inbox-ticket-card',
  imports: [
    GalaxyPipesModule,
    MatCardModule,
    MatIconModule,
    TranslateModule,
    ConversationPipesModule,
    GalaxyBadgeModule,
    MatButtonModule
],
  templateUrl: './inbox-ticket-card.component.html',
  styleUrls: ['./inbox-ticket-card.component.scss'],
})
export class InboxTicketCardComponent {
  protected ticketInfo: TicketInfo;
  protected isMinView = true;
  @Input() set ticketCardInfo(ticket: TicketInfo) {
    this.ticketInfo = ticket;
  }
  protected get badgeColor(): BadgeColor {
    return this.ticketInfo.badgeColor as BadgeColor;
  }
  showMoreLess() {
    this.isMinView = !this.isMinView;
  }
}
